import { reactive, toRefs } from "vue"

const state = reactive({
    app_member_active: false,
    login_biometric_member_active: false
})

function setState(data) {
    state.app_member_active = !!data.app_member_active
    state.login_biometric_member_active = !!data.login_biometric_member_active
}

export function useAppStore() {
    return {
        ...toRefs(state),
        setState
    }
}